const KEY_ID = 'last_spreadsheet_id';
const KEY_TITLE = 'last_spreadsheet_title';

export default {
  get() {
    return this.getId() && this.getTitle()
      ? { id: this.getId(), title: this.getTitle() }
      : null;
  },

  set(spreadsheet) {
    window.localStorage.setItem(KEY_ID, spreadsheet.id);
    window.localStorage.setItem(
      KEY_TITLE,
      spreadsheet._detail.properties.title
    );

    return this.get();
  },

  reset() {
    window.localStorage.removeItem('last_spreadsheet_id');
    window.localStorage.removeItem('last_spreadsheet_title');
  },

  getId() {
    return window.localStorage.getItem(KEY_ID);
  },

  getTitle() {
    return window.localStorage.getItem(KEY_TITLE);
  },
};
